"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SingleWomanActionsChat: ['single-woman-actions-chat', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M8.25,10.576A6.637,6.637,0,0,0,7.5,10.5,6.75,6.75,0,0,0,.75,17.25', 'M21.75,20.25h-3l-4.5,3v-3h-1.5a1.5,1.5,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5v6A1.5,1.5,0,0,1,21.75,20.25Z', 'M14.25 14.25L20.25 14.25', 'M14.25 17.25L20.25 17.25']],
  SingleWomanActions: ['single-woman-actions', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.476,23.25a10.483,10.483,0,0,0-18.952,0', 'M12,5.25A5.251,5.251,0,0,1,6.75,10.5a5.25,5.25,0,0,0,10.5,0A5.25,5.25,0,0,1,12,5.25Z', 'M17.836,19.027a14.576,14.576,0,0,0,3.391-1.007,1.5,1.5,0,0,0,.763-1.961l-1.376-3.21a4.5,4.5,0,0,1-.364-1.773V9A8.25,8.25,0,0,0,3.75,9v2.076a4.5,4.5,0,0,1-.364,1.773L2.01,16.059a1.5,1.5,0,0,0,.763,1.961,14.576,14.576,0,0,0,3.391,1.007']],
  SingleWomanActionsAddress: ['single-woman-actions-address', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M15.000 17.250 A2.250 2.250 0 1 0 19.500 17.250 A2.250 2.250 0 1 0 15.000 17.250 Z', 'M19.5,17.25v1.125a1.875,1.875,0,0,0,1.875,1.875h0a1.876,1.876,0,0,0,1.875-1.875v-.847a6.186,6.186,0,0,0-5.845-6.276,6,6,0,0,0-1.577,11.834,6.128,6.128,0,0,0,2.966-.037']],
  SingleWomanActionsCart: ['single-woman-actions-cart', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.508,11.211A6.675,6.675,0,0,0,7.5,10.5,6.75,6.75,0,0,0,.75,17.25', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M23.25,12l-2.821,7.756a.751.751,0,0,1-.7.494H14.357a.752.752,0,0,1-.69-.455L12.06,15.3a.749.749,0,0,1,.69-1.045h9.681', 'M15.375,22.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M19.125,22.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375']],
  SingleWomanActionsCheck2: ['single-woman-actions-check-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,17.25a6,6,0,1,1-6-6', 'M23.25,12.749l-5.47,5.47a.749.749,0,0,1-1.06,0L15,16.5', 'M3.376,4.986v1a5.9,5.9,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.388,5.2A5.483,5.483,0,0,0,7.5,3.305a5.483,5.483,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208']],
  SingleWomanActionsEmail: ['single-woman-actions-email', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.918,5.918,0,0,1-.859,3.273', 'M11.623,4.986v1a5.909,5.909,0,0,0,.86,3.273', 'M3.387,5.205A5.489,5.489,0,0,0,7.5,3.305a5.486,5.486,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M23.25,15.75v6a1.5,1.5,0,0,1-1.5,1.5h-9a1.5,1.5,0,0,1-1.5-1.5v-6', 'M23.25,15.75a1.5,1.5,0,0,0-1.5-1.5h-9a1.5,1.5,0,0,0-1.5,1.5L16.455,19a1.5,1.5,0,0,0,1.59,0Z']],
  SingleWomanActionsFlag: ['single-woman-actions-flag', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M11.25,11.639A6.748,6.748,0,0,0,.75,17.25', 'M14.25 12.75H23.25V18.75H14.25z', 'M14.25 12.75L14.25 23.25']],
  SingleWomanActionsEdit1: ['single-woman-actions-edit-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.63,14.869,15,22.5l-3.75.75L12,19.5l7.63-7.631a2.116,2.116,0,0,1,2.992,0l.008.009A2.113,2.113,0,0,1,22.63,14.869Z', 'M3.376,4.986v1a5.9,5.9,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.388,5.2A5.483,5.483,0,0,0,7.5,3.305a5.483,5.483,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.751,6.751,0,0,1,11.175-5.1']],
  SingleWomanActionsGraduate: ['single-woman-actions-graduate', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.25a6.75,6.75,0,0,1,11.787-4.494', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M16.5 14.308L9.75 17.087 16.5 19.558 23.25 17.087 16.5 14.308z', 'M9.75 17.065L9.75 20.837', 'M12.75,18.185V21.3a.75.75,0,0,0,.471.7l3,1.2a.745.745,0,0,0,.557,0l3-1.2a.75.75,0,0,0,.472-.7V18.185']],
  SingleWomanActionsImage: ['single-woman-actions-image', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.25A6.75,6.75,0,0,1,7.5,10.5a6.9,6.9,0,0,1,.75.041', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M11.250 11.250 L23.250 11.250 L23.250 23.250 L11.250 23.250 Z', 'M15.375,14.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M23.25,21l-2.391-3.587A.75.75,0,0,0,19.62,17.4l-2,2.851-1.237-.989a.749.749,0,0,0-1.092.169L12.75,23.25']],
  SingleWomanActionsKey: ['single-woman-actions-key', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.21,12.426A6.742,6.742,0,0,0,.75,17.25', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M15.575,18.925a.375.375,0,1,1-.531,0,.375.375,0,0,1,.531,0', 'M19.086,17.71l3.688-3.688a1.624,1.624,0,1,0-2.3-2.3L16.79,15.413a4.061,4.061,0,1,0,2.3,2.3Z']],
  SingleWomanActionsLocation: ['single-woman-actions-location', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,15.443a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M18.75,11.318a4.5,4.5,0,0,1,4.5,4.5c0,1.92-2.688,5.576-3.909,7.138a.75.75,0,0,1-1.182,0c-1.221-1.562-3.909-5.217-3.909-7.138A4.5,4.5,0,0,1,18.75,11.318Z', 'M12.21,12.432A6.742,6.742,0,0,0,.75,17.256', 'M3.376,4.992v1A5.912,5.912,0,0,1,2.517,9.26', 'M11.623,4.992v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.21A5.485,5.485,0,0,0,7.5,3.311a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.881 A4.125 4.125 0 1 0 11.625 4.881 A4.125 4.125 0 1 0 3.375 4.881 Z']],
  SingleWomanActionsMusic: ['single-woman-actions-music', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.000 21.375 A1.875 1.875 0 1 0 15.750 21.375 A1.875 1.875 0 1 0 12.000 21.375 Z', 'M19.500 19.125 A1.875 1.875 0 1 0 23.250 19.125 A1.875 1.875 0 1 0 19.500 19.125 Z', 'M15.75,21.375V14.581a1.5,1.5,0,0,1,1.025-1.423l4.5-1.25a1.5,1.5,0,0,1,1.975,1.423v5.794', 'M.75,17.25a6.75,6.75,0,0,1,11.787-4.494', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z']],
  SingleWomanActionsPlayer: ['single-woman-actions-player', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.25A6.75,6.75,0,0,1,7.5,10.5a6.9,6.9,0,0,1,.75.041', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M11.250 11.250 L23.250 11.250 L23.250 23.250 L11.250 23.250 Z', 'M15.75,17.25V15.43a.43.43,0,0,1,.651-.369l3.033,1.82a.429.429,0,0,1,0,.737L16.4,19.438a.429.429,0,0,1-.651-.368Z']],
  SingleWomanActionsRefresh: ['single-woman-actions-refresh', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M15 18.75L11.25 18.75 11.25 22.5', 'M22.667,19.483a5.572,5.572,0,0,1-10.74-.733', 'M19.5 15.75L23.25 15.75 23.25 12', 'M11.832,15.017a5.572,5.572,0,0,1,10.74.733']],
  SingleWomanActionsSetting: ['single-woman-actions-setting', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.750 16.500 A1.500 1.500 0 1 0 18.750 16.500 A1.500 1.500 0 1 0 15.750 16.500 Z', 'M18.524,10.7l.442,1.453a.993.993,0,0,0,1.173.681l1.473-.341a1.338,1.338,0,0,1,1.274,2.218l-1.03,1.111a1,1,0,0,0,0,1.362l1.03,1.111a1.338,1.338,0,0,1-1.274,2.218l-1.473-.341a.993.993,0,0,0-1.173.681L18.524,22.3a1.331,1.331,0,0,1-2.549,0l-.442-1.453a.993.993,0,0,0-1.173-.681l-1.473.341a1.338,1.338,0,0,1-1.274-2.218l1.03-1.111a1,1,0,0,0,0-1.362l-1.03-1.111a1.338,1.338,0,0,1,1.274-2.218l1.473.341a.993.993,0,0,0,1.173-.681l.442-1.453A1.331,1.331,0,0,1,18.524,10.7Z', 'M3.376,4.986v1a5.918,5.918,0,0,1-.859,3.273', 'M11.623,4.986v1a5.909,5.909,0,0,0,.86,3.273', 'M3.387,5.205A5.489,5.489,0,0,0,7.5,3.305a5.486,5.486,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208']],
  SingleWomanActionsStar: ['single-woman-actions-star', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.946,11.68,19.488,15h3a.735.735,0,0,1,.518,1.283l-2.6,2.562,1.443,3.314a.786.786,0,0,1-1.119.982l-3.487-1.961-3.486,1.961a.786.786,0,0,1-1.12-.982l1.443-3.314-2.6-2.562A.734.734,0,0,1,11.988,15h3l1.544-3.323A.8.8,0,0,1,17.946,11.68Z', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208']],
  SingleWomanActionsShare2: ['single-woman-actions-share-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25A6.75,6.75,0,0,1,12,12.219', 'M11.250 18.000 A2.250 2.250 0 1 0 15.750 18.000 A2.250 2.250 0 1 0 11.250 18.000 Z', 'M18.750 21.000 A2.250 2.250 0 1 0 23.250 21.000 A2.250 2.250 0 1 0 18.750 21.000 Z', 'M18.750 13.500 A2.250 2.250 0 1 0 23.250 13.500 A2.250 2.250 0 1 0 18.750 13.500 Z', 'M15.424 16.845L19.074 14.655', 'M15.588 18.835L18.912 20.165']],
  SingleWomanActionsTime: ['single-woman-actions-time', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M19.901 17.25L17.25 17.25 17.25 14.598']],
  SingleWomanActionsView: ['single-woman-actions-view', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.757,6.757,0,0,1,8.259-6.581', 'M10.500 15.750 A5.250 5.250 0 1 0 21.000 15.750 A5.250 5.250 0 1 0 10.500 15.750 Z', 'M23.25 23.25L19.462 19.462']],
  SingleWomanActionsVideo: ['single-woman-actions-video', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,15.75l-3,1v-1a1.5,1.5,0,0,0-1.5-1.5h-6a1.5,1.5,0,0,0-1.5,1.5v6a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-1l3,1Z', 'M.75,17.25A6.753,6.753,0,0,1,10.5,11.2', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z']],
  SingleWomanActionsCheck1: ['single-woman-actions-check-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.247 A6.000 6.000 0 1 0 23.250 17.247 A6.000 6.000 0 1 0 11.250 17.247 Z', 'M19.924,15.5l-2.905,3.874a.751.751,0,0,1-1.131.08l-1.5-1.5', 'M3.376,4.989v1a5.906,5.906,0,0,1-.859,3.272', 'M11.623,4.989v1a5.905,5.905,0,0,0,.86,3.272', 'M3.388,5.207A5.486,5.486,0,0,0,7.5,3.308a5.486,5.486,0,0,0,4.112,1.9', 'M3.375 4.878 A4.125 4.125 0 1 0 11.625 4.878 A4.125 4.125 0 1 0 3.375 4.878 Z', 'M.75,17.253a6.753,6.753,0,0,1,9.4-6.208']],
  SingleWomanActionsDownload: ['single-woman-actions-download', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 14.25L17.25 20.25', 'M17.25 20.25L15 18', 'M17.25 20.25L19.5 18']],
  SingleWomanActionsCoding: ['single-woman-actions-coding', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M15.75 15.75L14.25 17.25 15.75 18.75', 'M18.75 15.75L20.25 17.25 18.75 18.75']],
  SingleWomanActionsFlash: ['single-woman-actions-flash', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.75,6.75,0,0,1,11.957-4.295', 'M20.25,9.75l-5.911,6.882a.375.375,0,0,0,.286.618H17.25v6l5.91-6.882a.375.375,0,0,0-.285-.618H20.25Z']],
  SingleWomanActionsLaptop: ['single-woman-actions-laptop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.9,17.25a6.75,6.75,0,0,1,6.75-6.75,6.9,6.9,0,0,1,.75.041', 'M3.521,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.768,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.532,5.2a5.485,5.485,0,0,0,4.113-1.9,5.481,5.481,0,0,0,4.112,1.9', 'M3.520 4.875 A4.125 4.125 0 1 0 11.770 4.875 A4.125 4.125 0 1 0 3.520 4.875 Z', 'M21.9,12.75v6H11.4v-6a1.5,1.5,0,0,1,1.5-1.5h7.5A1.5,1.5,0,0,1,21.9,12.75Z', 'M11.4,18.75H21.9l1.171,3.513a.751.751,0,0,1-.712.987H10.935a.75.75,0,0,1-.711-.987Z']],
  SingleWomanActionsHome: ['single-woman-actions-home', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75,15.948v5.8a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-5.8', 'M11.25,17.26l4.518-3.954a2.25,2.25,0,0,1,2.963,0L23.25,17.26', 'M18.75,23.25h-3v-3a1.5,1.5,0,0,1,3,0Z', 'M.75,17.25A6.751,6.751,0,0,1,12,12.219', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z']],
  SingleWomanActionsHeart: ['single-woman-actions-heart', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.25,23.25l-5.114-5.335a3.025,3.025,0,0,1-.567-3.492h0a3.026,3.026,0,0,1,4.846-.787l.835.835.835-.835a3.025,3.025,0,0,1,4.845.787h0a3.025,3.025,0,0,1-.567,3.492Z', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208']],
  SingleWomanActionsMoney: ['single-woman-actions-money', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M18.75,14.25H16.716a1.342,1.342,0,0,0-.5,2.587l2.063.825a1.342,1.342,0,0,1-.5,2.588H15.75', 'M17.25 14.035L17.25 13.5', 'M17.25 21L17.25 20.464', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z']],
  SingleWomanActionsShare1: ['single-woman-actions-share-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.886,13.5A6.751,6.751,0,0,1,23.25,17.25', 'M12.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M20.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M12.387,5.2a5.485,5.485,0,0,0,4.113-1.9,5.481,5.481,0,0,0,4.112,1.9', 'M12.375 4.875 A4.125 4.125 0 1 0 20.625 4.875 A4.125 4.125 0 1 0 12.375 4.875 Z', 'M0.75 14.25L0.75 23.25', 'M.75,21.75h15a3,3,0,0,0-3-3H9a3,3,0,0,0-3-3H.75', 'M6 18.75L9 18.75']],
  SingleWomanActionsQuestion: ['single-woman-actions-question', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M15.375,16.125A1.875,1.875,0,1,1,17.25,18', 'M17.25 20.25L17.25 20.25', 'M17.25,20.25a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375']],
  SingleWomanActionsShield: ['single-woman-actions-shield', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M8.25,10.576A6.637,6.637,0,0,0,7.5,10.5,6.75,6.75,0,0,0,.75,17.25', 'M23.25,15.75a7.669,7.669,0,0,1-6,7.5,7.668,7.668,0,0,1-6-7.5v-3a1.5,1.5,0,0,1,1.5-1.5h9a1.5,1.5,0,0,1,1.5,1.5Z', 'M17.25 15L17.25 19.5', 'M15 17.25L19.5 17.25']],
  SingleWomanActionsSync: ['single-woman-actions-sync', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M19.5 15.75L23.25 15.75 23.25 11.25', 'M23.061,15.75a6,6,0,1,0-1.122,5.242']],
  SingleWomanActionsUpDown: ['single-woman-actions-up-down', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.25a6.75,6.75,0,0,1,11.243-5.037', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M11.25 20.25L14.25 23.25 17.25 20.25', 'M14.25 23.25L14.25 14.25', 'M17.25 17.25L20.25 14.25 23.25 17.25', 'M20.25 14.25L20.25 23.25']],
  SingleWomanActionsUpload: ['single-woman-actions-upload', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.918,5.918,0,0,1-.859,3.273', 'M11.623,4.986v1a5.909,5.909,0,0,0,.86,3.273', 'M3.387,5.205A5.489,5.489,0,0,0,7.5,3.305a5.486,5.486,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 20.25L17.25 14.25', 'M17.25 14.25L15 16.5', 'M17.25 14.25L19.5 16.5']],
  SingleWomanActionsWifi: ['single-woman-actions-wifi', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M17.25,22.424a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M23.25,15.622a9.542,9.542,0,0,0-12,0', 'M13.749,19.238a5.567,5.567,0,0,1,7,0']],
  SingleWomanActionsBlock: ['single-woman-actions-block', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.241,17.249a6,6,0,1,1,6,6A6,6,0,0,1,11.241,17.249Z', 'M13 21.49L21.483 13.006', 'M3.376,4.987v1a5.91,5.91,0,0,1-.859,3.273', 'M11.623,4.987v1a5.909,5.909,0,0,0,.86,3.273', 'M3.388,5.206A5.487,5.487,0,0,0,7.5,3.306a5.487,5.487,0,0,0,4.112,1.9', 'M3.375 4.876 A4.125 4.125 0 1 0 11.625 4.876 A4.125 4.125 0 1 0 3.375 4.876 Z', 'M.75,17.251a6.753,6.753,0,0,1,9.4-6.208']],
  SingleWomanActionsCreditCard: ['single-woman-actions-credit-card', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 14.250 L23.250 14.250 L23.250 23.250 L11.250 23.250 Z', 'M11.25 17.25L23.25 17.25', 'M17.25 20.25L20.25 20.25', 'M.75,17.25A6.753,6.753,0,0,1,10.5,11.2', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z']],
  SingleWomanActionsMobilephone: ['single-woman-actions-mobilephone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.25A6.75,6.75,0,0,1,13.111,13.5', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M19.5,19.875a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375', 'M15.750 11.250 L23.250 11.250 L23.250 23.250 L15.750 23.250 Z']],
  SingleWomanActionsMonitor: ['single-woman-actions-monitor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,17.25A6.75,6.75,0,0,1,7.5,10.5a6.9,6.9,0,0,1,.75.041', 'M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M11.250 11.250 L23.250 11.250 L23.250 20.250 L11.250 20.250 Z', 'M14.25 23.25L20.25 23.25', 'M17.25 23.25L17.25 20.25']],
  SingleWomanActionsSubtract: ['single-woman-actions-subtract', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.249 A6.000 6.000 0 1 0 23.250 17.249 A6.000 6.000 0 1 0 11.250 17.249 Z', 'M14.25 17.249L20.25 17.249', 'M3.373,4.987v1a5.909,5.909,0,0,1-.859,3.272', 'M11.62,4.987v1a5.908,5.908,0,0,0,.86,3.272', 'M3.385,5.205A5.486,5.486,0,0,0,7.5,3.306a5.486,5.486,0,0,0,4.112,1.9', 'M3.372 4.875 A4.125 4.125 0 1 0 11.622 4.875 A4.125 4.125 0 1 0 3.372 4.875 Z', 'M.75,17.25a6.751,6.751,0,0,1,9.4-6.208']],
  SingleWomanActionsAdd: ['single-woman-actions-add', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 14.25L17.25 20.25', 'M14.25 17.25L20.25 17.25', 'M3.376,4.986v1a5.9,5.9,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.388,5.2A5.483,5.483,0,0,0,7.5,3.305a5.483,5.483,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208']],
  SingleWomanActionsAlarm: ['single-woman-actions-alarm', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,16.875a6.753,6.753,0,0,1,9.4-6.208', 'M3.376,4.611v1A5.918,5.918,0,0,1,2.517,8.88', 'M11.623,4.611v1a5.909,5.909,0,0,0,.86,3.273', 'M3.387,4.83A5.489,5.489,0,0,0,7.5,2.93a5.486,5.486,0,0,0,4.112,1.9', 'M3.375 4.500 A4.125 4.125 0 1 0 11.625 4.500 A4.125 4.125 0 1 0 3.375 4.500 Z', 'M18,11.625a3.75,3.75,0,0,1,3.75,3.75v3a1.5,1.5,0,0,0,1.5,1.5H12.75a1.5,1.5,0,0,0,1.5-1.5v-3A3.75,3.75,0,0,1,18,11.625Z', 'M18,22.125a.375.375,0,1,1-.375.375A.375.375,0,0,1,18,22.125']],
  SingleWomanActionsFlight: ['single-woman-actions-flight', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.872,13.623a1.765,1.765,0,0,1,.993.618,1.8,1.8,0,0,1-.436,2.617l-10.142,6.3a.624.624,0,0,1-.688-.02l-3.718-2.61a.343.343,0,0,1-.052-.483c.017-.022,1.619-1.434,1.619-1.434a.342.342,0,0,1,.331-.057l1.956,1.165,2.48-1.73-4.7-2.91a.427.427,0,0,1-.048-.6c.02-.024,1.217-.916,1.217-.916a.425.425,0,0,1,.4-.057l6.477,2.411,3-2.045A1.671,1.671,0,0,1,21.872,13.623Z', 'M9.968,10.967A6.749,6.749,0,0,0,.752,17.25', 'M3.379,4.986v1a5.9,5.9,0,0,1-.86,3.272', 'M11.626,4.986v1a5.912,5.912,0,0,0,.859,3.272', 'M3.39,5.2A5.481,5.481,0,0,0,7.5,3.305a5.485,5.485,0,0,0,4.112,1.9', 'M3.377 4.875 A4.125 4.125 0 1 0 11.627 4.875 A4.125 4.125 0 1 0 3.377 4.875 Z']],
  SingleWomanActionsInformation: ['single-woman-actions-information', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.753,6.753,0,0,1,9.4-6.208', 'M11.250 17.250 A6.000 6.000 0 1 0 23.250 17.250 A6.000 6.000 0 1 0 11.250 17.250 Z', 'M17.25 20.25L17.25 17.25', 'M17.25 14.31L17.25 14.31', 'M17.25,14.31a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375']],
  SingleWomanActionsLock: ['single-woman-actions-lock', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.75,6.75,0,0,1,11.78-4.5', 'M14.250 15.750 L23.250 15.750 L23.250 23.250 L14.250 23.250 Z', 'M18.75,11.25h0a3,3,0,0,0-3,3v1.5h6v-1.5A3,3,0,0,0,18.75,11.25Z', 'M18.75 19.154L18.75 19.154', 'M18.75,19.154a.375.375,0,1,0,.375.375.374.374,0,0,0-.375-.375']],
  SingleWomanActionsRemove: ['single-woman-actions-remove', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 17.249 A6.000 6.000 0 1 0 23.250 17.249 A6.000 6.000 0 1 0 11.250 17.249 Z', 'M19.5 14.998L15 19.498', 'M15 14.998L19.5 19.498', 'M3.377,4.987v1a5.909,5.909,0,0,1-.86,3.273', 'M11.624,4.987v1a5.91,5.91,0,0,0,.859,3.273', 'M3.388,5.206A5.487,5.487,0,0,0,7.5,3.306a5.487,5.487,0,0,0,4.112,1.9', 'M3.375 4.876 A4.125 4.125 0 1 0 11.625 4.876 A4.125 4.125 0 1 0 3.375 4.876 Z', 'M.75,17.251a6.753,6.753,0,0,1,9.4-6.208']],
  SingleWomanActionsText: ['single-woman-actions-text', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.387,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M8.25,10.576A6.637,6.637,0,0,0,7.5,10.5,6.75,6.75,0,0,0,.75,17.25', 'M11.250 11.250 L23.250 11.250 L23.250 23.250 L11.250 23.250 Z', 'M14.25 14.25L20.25 14.25', 'M14.25 17.25L20.25 17.25', 'M14.25 20.25L16.5 20.25']],
  SingleWomanActionsWarning: ['single-woman-actions-warning', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.376,4.986v1a5.912,5.912,0,0,1-.859,3.272', 'M11.623,4.986v1a5.9,5.9,0,0,0,.86,3.272', 'M3.388,5.2A5.485,5.485,0,0,0,7.5,3.305a5.481,5.481,0,0,0,4.112,1.9', 'M3.375 4.875 A4.125 4.125 0 1 0 11.625 4.875 A4.125 4.125 0 1 0 3.375 4.875 Z', 'M.75,17.25a6.75,6.75,0,0,1,11.3-4.983', 'M17.25 20.25L17.25 20.25', 'M17.25,20.25a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375', 'M17.25 18L17.25 15', 'M23.062,20.682a1.774,1.774,0,0,1-1.587,2.568H13.024a1.775,1.775,0,0,1-1.587-2.568l4.226-8.452a1.774,1.774,0,0,1,3.173,0Z']]
};
exports["default"] = _default;